import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoadingBar from "./LoadingBar";

const Navbar = (props) => {
  let location = useLocation();
  let navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("auth-token");
    localStorage.removeItem("userName");
    localStorage.removeItem("userEmail");
    navigate("/auth/login");
  };
  return (
    <>
      <nav
        className={`navbar sticky-top navbar-expand-lg bg-${
          props.theme === "dark" ? "dark" : "light"
        } navbar-${props.theme === "dark" ? "dark" : "light"}`}
      >
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <i className="uil uil-notebooks"></i> NoteBoss
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname === "/" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/"
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname === "/addNote" ? "active" : ""
                  }`}
                  to="/addnote"
                >
                  Add Note
                </Link>
              </li>
            </ul>
            {localStorage.getItem("auth-token") === null ? (
              <>
                <Link
                  className="btn btn-primary ms-2"
                  to="/auth/login"
                  role="button"
                >
                  Login
                </Link>
                <Link
                  className="btn btn-primary mx-2"
                  to="/auth/signup"
                  role="button"
                >
                  SignUp
                </Link>
              </>
            ) : (
              <>
                <div className="loggedInUserDiv">
                  <ul className="navbar-nav">
                    <li className="nav-item dropdown">
                      <button
                        className={`btn ${props.theme==="dark"?"btn-dark":""} dropdown-toggle mx-2`}
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span className="text-danger">Hi, </span><span className="me-2 text-danger">{localStorage.getItem('userName')}</span>
                      </button>
                      <ul className={`dropdown-menu ${props.theme==="dark"?"dropdown-menu-dark":""}`}>
                        <li>
                          <Link className="dropdown-item" to='/youraccount'>
                            Your Account
                          </Link>
                        </li>
                        <li>
                          <button className="dropdown-item" onClick={handleLogout}>
                            Logout
                          </button>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </>
            )}
            <i
              className={`uil uil-${
                props.theme === "dark" ? "brightness" : "moon"
              } text-${props.theme === "dark" ? "light" : "dark"} mx-1`}
              onClick={props.themeChanger}
              style={{ cursor: "pointer", fontSize: "26px", fillOpacity: "" }}
            ></i>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
